export default "__VITE_ASSET__2a355fe4__"